import { memo } from 'react';
import styled, { type CSSObject } from '@emotion/styled';

import type { ThemeProps } from '@emotion/react';

import { getInitials } from '../../../lib/getInitials';
import { themeFont } from '../../../lib/themeFont';
import useDateDisplayWithFormat from '../../../lib/useDateDisplayWithFormat';

import type { Maybe } from '../../../types/graphql';

const LogoWrap = styled("div")`
  letter-spacing: 3.4px;
  line-height: 1;
  margin: 52px auto;
  text-align: center;
  width: fit-content;
  ${(props: ThemeProps): CSSObject | undefined =>
    props.theme?.components?.InitialsDateLockup}
`;

const Initials = styled("div")`
  padding: 0 18px 16px;

  ${themeFont('s1')}
`;

const LogoDate = styled("div")`
  padding: 20px 18px 0;

  ${themeFont('s5')}

  border-top: 1px solid
  ${({ theme: { components, fonts } }: ThemeProps) => {
    const borderColor = components?.InitialsDateLockup?.borderColor;

    return borderColor || fonts.s1.color;
  }};
`;

export interface InitialsDateLockupProps {
  firstName?: Maybe<string> | undefined;
  fianceFirstName?: Maybe<string> | undefined;
}

function InitialsDateLockup({
  firstName,
  fianceFirstName,
}: InitialsDateLockupProps) {
  const initials = getInitials({ firstName, fianceFirstName });

  const formattedDate = useDateDisplayWithFormat('short');

  if (!initials) {
    return null;
  }

  return (
    <LogoWrap>
      <Initials>{initials}</Initials>

      {formattedDate ? <LogoDate>{formattedDate}</LogoDate> : null}
    </LogoWrap>
  );
}

export default memo(InitialsDateLockup);
